export const getCsrfToken = (): string => {
  const csrfToken = getMetaContent("csrf-token");

  if (!csrfToken) {
    throw new Error("CSRF Token not found");
  } else {
    return csrfToken;
  }
};

export const getMetaContent = (name: string): string | undefined => {
  const metaElement = document.querySelector<HTMLMetaElement>(`meta[name=${name}]`);
  if (!metaElement) {
    return;
  }

  return metaElement.content;
};

export const setMeta = (name: string, content: string): void => {
  const meta = document.createElement("meta");
  meta.setAttribute("name", name);
  meta.setAttribute("content", content);
  document.head.appendChild(meta);
};
